export interface IApSbsItem {
    id: number,
    invoiceDate: string,
    swapNumber: number,
    swap: string,
    donorCenterAlias: string,
    donorCenterId: number,
    donorId: number,
    donorAlias: string, 
    recipientCenterAlias: string,
    recipientCenterId: number,
    recipientId: number,
    recipientAlias: string,
    comments: string,
    surgeonFee: number,
    anesthesiologistFee: number
    hospitalFee: number,
    totalFees: number,
    daysOutstanding: number,
    paidDateTime: string,
    achConfirmation: string,
    hasLate: boolean,
    hasOutstandingDelinquency: boolean,
    ccbPayableDays: number,
    centerHasAchOnFile: boolean
}